import { useLayoutEffect, useRef, useState } from 'react'

import {
  isEventKeyEnter,
  isEventKeySpaceBar,
  preventDefault,
} from '../../../../../../utils/events'
import { useRisingEdgeEffect } from '../../../../ColorPicker.hooks'
import { isColorFormatHex } from '../../../../ColorPicker.utils'

export function useColorPickerPreviewValueFocus({
  colorFormat,
  isPopoverOpen,
  rgbInputRef,
  valueInputRef,
}) {
  const [isValueInputFocused, setIsValueInputFocused] = useState(false)

  const prevIsValueInputFocusedRef = useRef(false)

  function handlePopoverOpen() {
    setIsValueInputFocused(false)
  }

  useRisingEdgeEffect({ value: isPopoverOpen, onRisingEdge: handlePopoverOpen })

  useLayoutEffect(() => {
    if (isValueInputFocused && !prevIsValueInputFocusedRef.current) {
      if (isColorFormatHex(colorFormat)) {
        valueInputRef.current?.focus()
      } else {
        rgbInputRef.current?.focus()
      }
    }

    prevIsValueInputFocusedRef.current = isValueInputFocused
  }, [colorFormat, isValueInputFocused, rgbInputRef, valueInputRef])

  function handleValueTextTriggerClick() {
    setIsValueInputFocused(true)
  }

  function handleValueTextTriggerKeyDown(event) {
    if (isEventKeyEnter(event) || isEventKeySpaceBar(event)) {
      preventDefault(event)
      setIsValueInputFocused(true)
    }
  }

  return {
    handleValueTextTriggerClick,
    handleValueTextTriggerKeyDown,
    isValueInputFocused,
    setIsValueInputFocused,
  }
}
